"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var emit = function (eventName, eventData) {
    var newrelicLoaded = typeof newrelic !== 'undefined';
    if (!newrelicLoaded) {
        return;
    }
    newrelic.addPageAction(eventName, eventData);
};
var setCustomAttribute = function (name, value) {
    var newrelicLoaded = typeof newrelic !== 'undefined';
    if (!newrelicLoaded) {
        return;
    }
    newrelic.setCustomAttribute(name, value);
};
exports.default = { emit: emit, setCustomAttribute: setCustomAttribute };
